import { Box, Select, MenuItem, SxProps, Theme, Chip } from "@mui/material";

export const Measure = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  measure: string;
  setMeasure: (measure: string) => void;
  columns: { name: string; caption: string }[];
  disabled: boolean;
}) => {
  const { sx, measure, setMeasure, columns, isLoading, disabled } = props;
  const columnValid = columns.some((c) => c.name === measure);

  return (
    <Box sx={sx}>
      <Box sx={{ fontSize: 11, mb: 0.1 }}>Aggregate by</Box>
      <Select
        disabled={isLoading || !columnValid || disabled}
        variant="standard"
        size="small"
        // it's ok as long as we have only one level of hierarchy
        // which is what we aggreed on for now
        value={columnValid ? measure : ""}
        renderValue={(value) => (
          <Chip
            key={value}
            label={columns.find((column) => column.name === value)?.caption}
            size="small"
            sx={{
              backgroundColor: "action.selected",
            }}
          />
        )}
        onChange={async (event) => {
          const newValue = event.target.value as string;
          setMeasure(newValue);
        }}
      >
        {columns.map((column, index) => (
          <MenuItem key={index} value={column.name}>
            {column.caption}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
